<template>
  <div class="form-col">
    <div class="form-item">
      <label class="form-label">
        <span class="label-text">总消费金额（元）：</span>
        <span class="label-tip">💰</span>
      </label>
      <div class="input-container">
        <input 
          type="number" 
          v-model.number="totalAmount" 
          min="0" 
          placeholder="请输入总消费金额（元），留空则自动计算"
          class="form-input"
          @input="handleInput"
        >
        <small class="input-hint">提示：留空时，系统将根据参与人实付金额自动计算总金额</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalAmountInput',
  props: {
    modelValue: {
      type: Number,
      default: 0
    }
  },
  computed: {
    totalAmount: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    handleInput() {
      this.$emit('change', this.totalAmount)
    }
  }
}
</script>

<style scoped>
/* 表单卡片样式 */
.form-item {
  margin-bottom: 0;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: none;
}

.form-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* 表单标签样式 */
.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 12px;
  font-size: 14px;
}

.label-text {
  font-weight: 600;
  color: #4a5568;
}

.label-tip {
  font-size: 18px;
}

/* 输入容器样式 */
.input-container {
  margin-bottom: 0;
}

/* 输入框样式 */
.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  background: #fafafa;
  color: #2d3748;
}

.form-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: #ffffff;
}

.form-input::placeholder {
  color: #a0aec0;
}

/* 输入提示文字 */
.input-hint {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #718096;
  font-style: italic;
  line-height: 1.4;
}

/* 响应式布局 */
@media (max-width: 750px) {
  .form-item {
    padding: 12px;
    border-radius: 8px;
  }
  
  .form-label {
    font-size: 13px;
    margin-bottom: 8px;
  }
  
  .form-input {
    padding: 8px 12px;
    font-size: 13px;
    border-radius: 4px;
  }
  
  .input-hint {
    font-size: 11px;
  }
}

@media (max-width: 320px) {
  .form-item {
    padding: 10px;
  }
  
  .form-label {
    font-size: 12px;
  }
  
  .form-input {
    padding: 7px 10px;
    font-size: 12px;
  }
  
  .label-tip {
    font-size: 16px;
  }
  
  .input-hint {
    font-size: 10px;
  }
}
</style>